import type { QueryClient } from "@tanstack/react-query";

import { fetchEmployees } from "../../../api/services";

export type EmployeeValue = {
	id: string;
	name: string;
};

export const createFetchEmployeesForPicker = (queryClient: QueryClient) => {
	return async (searchTerm: string): Promise<{ id: string; name: string }[]> => {
		const cachedData = queryClient.getQueryData<{ id: string; name: string }[]>([
			"selectEmployeeFilter",
			searchTerm,
		]);
		if (cachedData) {
			return cachedData;
		}

		const data = await fetchEmployees({ searchTerm });
		const employees =
			data.users?.map((user) => ({
				id: user._id,
				name: user.name,
			})) || [];

		queryClient.setQueryData(["selectEmployeeFilter", searchTerm], employees);

		return employees;
	};
};
